
export const BASE = process.env.REACT_APP_BACKEND_IP;
//"REACT_APP_BACKEND_IP": "10.100.79.46",
//"REACT_APP_BACKEND_PORT": "8280",
// https://qa-back-gmm.inter.mx/ApiGMM/
//export const IP = 'http://35.208.56.171/';
export const API = 'ApiGMM/';
export const PATH = BASE+API;
export const CLIENT_ID = "620fd2edb9ff73001b40df53";
export const FLOW_ID = "62168532cee616001c0637bb";
// export const CLIENT_COT_ID = process.env.CLIENT_COT_ID 
// export const CLIENT_SECRET = process.env.CLIENT_SECRET
export const CLIENT_COT_ID = "bMs1oY7IF1ZA3X4cXdsEKzrbjzlujxy2" 
export const CLIENT_SECRET = "E8i0pt1PaKoghd_1C096ydxgaqFIsmxoJ6fx5etCwmcpPkt_oeYX_dEAJ41i5u3A"

export const CAT = 'catalogos/';
export const ASEG = 'Aseguradoras/'
export const INTER_CONTRATANTE = 'interContratante';
export const TIPO_FLUJO = 'tipoFlujo';
export const INTER_PADECIMIENTOS = 'padecimientos';
export const EXCLUSION_M = 'exclusionMayor';
export const EXCLUSION_E = 'exclusionEmbarazo';


//validaciones
export const VACIO = "";
export const UN_CRITERIO = "Debe proporcionar al menos un crtierio de búsqueda.";
export const VALOR_NECESARIO = "¡Oh, no! Te falta llenar este campo para poder continuar.";
export const FECHA_VALIDA = "Ingrese una fecha válida";
export const CMB_NECESARIO = "Seleccione una opción válida";
export const VALOR_POSITIVO = "Ingrese un valor positivo";
export const VALOR_NUMERO = "Ingrese un número";
export const VALOR_ENTERO = "Ingrese un número entero";
export const CORREO_INVALIDO = "Ingrese un correo válido";
export const TELEFONO_INVALIDO = "¡Oops! Debes ingresar un teléfono válido.";
export const CP_INVALIDO = "Ingrese un código postal válido";
export const EDAD_INVALIDA = "Ingrese una edad válida";
export const CMB_MENOS_UNO = -1;
export const CMB_NULL = null;
export const EMPTY = "";
export const EMAIL_INCORRECTO = "¡Oh, no! El email que ingresaste no es correcto. Chécalo para continuar."
export const MIN_LETRAS_DES_AUTO = 3;
export const MAX_LENGTH_CP = 5;
export const CHECK_NECESARIO = "Seleccione una opción";
export const MAX_LENGTH_NUM_TARJETA = 16;
export const MAX_LENGTH_CVV = 4;
export const ERROR_MSG = "Te pedimos una disculpa, hubo un error al realizar tu consulta.";
export const MAX_LENGTH_NAME = 'Debe tener como máximo 20 caracteres';
export const ERROR_TITULO_MSG = "¡Sucedió un Error!";
export const ERROR_MSG_1 = "El número de serie ya esta amparado en otra póliza";
export const ERROR_TITULO_MSG_1 = "Validación de número de serie";
export const MAX_LENGTH_NO_SERIE = 17;
export const MAX_LENGTH_PLACAS = 7;
export const MAX_LENGTH_RFC = 13;
export const MAX_LENGTH_RFC_M = 12;
export const MAYOR_EDAD = "Debe ser mayor de edad";
export const AUTOCOMPLETE = "Debe escribir para buscar su auto";
export const REQUERIDO = "Se requiere aceptar Aviso de privacidad y Términos y Condiciones";
export const MSG_FALTA_INFO = "¡Ayúdanos a revisar el formulario!, parece que falta información";
//valores para rango de edad para pregunar si una mujer esta embarazada
export const EDAD_MUJER_MIN = 10;
export const EDAD_MUJER_MAX = 50;

export const initYear = 2000;
export const meses = [
{id:1,nombre:'Enero'},
{id:2,nombre:'Febrero'},
{id:3,nombre:'Marzo'},
{id:4,nombre:'Abril'},
{id:5,nombre:'Mayo'},
{id:6,nombre:'Junio'},
{id:7,nombre:'Julio'},
{id:8,nombre:'Agosto'},
{id:9,nombre:'Septiembre'},
{id:10,nombre:'Octubre'},
{id:11,nombre:'Noviembre'},
{id:12,nombre:'Diciembre'}]

export const CANTIDAD_MAX = 50;

export const STATUS = {
  ACCEPTED: 200,
  REJECTED: 500,
  INDETERMINATE: 400
}

export const frecuencias = [
  "Diario",
  "Semana",
  "Trimestre",
  "Anual",
];

export const ultimaVez = [
	"Menos de 12 meses",
	"Más de 12 meses",
];

export const resultadoRevision = [
    "Todo en orden",
    "Me detectaron algo",
];

export const resultadoRevisionAdicional = [
    "Todo en orden",
    "Le detectaron algo",
];

/*export const TEXT_MAX = 'Debe tener como máximo ${max} caracteres';
export const TEXT_MIN = 'Debe tener ${min} caracteres';
export const TEXT_MIN_MAX = 'Debe tener ${max} caracteres';*/


export const descripcionTarjetaTipoEventos = "Por favor agrega a cada uno de los accidentes o enfermedades que hayan requerido hospitalización";
export const descripcionTarjetaAdicionales = "Por favor agrega a cada una de las personas que te gustaría asegurar";


/* lista componentes*/
export const BIENVENIDA = "bienvenida";
export const DATOS = "datos";
export const PERSONA_MAYOR = "personaMayor";
export const EMBARAZO = "embarazo";
export const ALGUIEN_MAS = "alguienMas";
export const SOLO_AM = "soloAlguienMas";
export const SOLO_AM_AGREGAR = "soloAlguienMasAgregarMas";

export const MSG030 = "Error interno, por favor notifique a su Administrador de Sistemas.";

//valores flujo mati
export const INE = "INE";
export const DOMICILIO = "DOMICILIO";
export const TELEFONO = "TELEFONO";
export const CORREO = "CORREO";
export const CONTACTO = "CONTACTO";
export const GOBER = "GOBER";


//4 pasos del cuestionario
export const primer = {
  paso: 1,
  titulo:"ESTILO DE VIDA",
  textoPaso:"Paso 1 de 4",
  pasos:[
    {
      activo:true},
    {
      activo:false},
    {
      activo:false},
    {
      activo:false},
  ]
};
export const segundo = {
  paso: 2,
  titulo:"información básica de salud",
  textoPaso:"Paso 2 de 4",
  pasos:[
    {
      activo:true},
    {
      activo:true},
    {
      activo:false},
    {
      activo:false},
  ]
};
export const tercero = {
  paso: 3,
  titulo:"PADECIMIENTOS",
  textoPaso:"Paso 3 de 4",
  pasos:[
    {
      activo:true},
    {
      activo:true},
    {
      activo:true},
    {
      activo:false},
  ]
};
export const cuarto = {
  paso: 4,
  titulo:"Prevención y control",
  textoPaso:"Paso 4 de 4",
  pasos:[
    {
      activo:true},
    {
      activo:true},
    {
      activo:true},
    {
      activo:true},
  ]
};

//3 pasos del cuestionario
export const segundoAlt = {
  paso: 2,
  titulo:"información básica de salud",
  textoPaso:"Paso 1 de 3",
  pasos:[
    {
      activo:true},
    {
      activo:false},
    {
      activo:false},
  ]
};
export const terceroAlt = {
  paso: 3,
  titulo:"PADECIMIENTOS",
  textoPaso:"Paso 2 de 3",
  pasos:[
    {
      activo:true},
    {
      activo:true},
    {
      activo:false},
  ]
};
export const cuartoAlt = {
  paso: 4,
  titulo:"Prevención y control",
  textoPaso:"Paso 3 de 3",
  pasos:[
    {
      activo:true},
    {
      activo:true},
    {
      activo:true},
  ]
};

/**  contratacion */
//hay que agregar un paso más a todos los flujos pero antes del paso de la firma y luego el boton de continuar del nuevo paso debe llamar el  flujo mati
//pasos de contratacion flujo 1 contratante titular CT
export const pasoCTFlujo1 = {
  paso: 1,
  titulo:"DATOS DEL CONTRATANTE (ASEGURADO TITULAR)",
 /* textoPaso:"Paso 1 de 3",*/
  textoPaso:"Paso 1 de 2",
  pasos:[
    { activo:true },
    { activo:false },
    /*{ activo:false },*/
  ]
};

/*
export const pasoDocsFlujo1 = {
  paso: 4,
  titulo:"CARGA DE DOCUMENTOS Y VALIDACIÓN DE DATOS",
  textoPaso:"Paso 2 de 3",
  pasos:[
    { activo:true },
    { activo:true },
    { activo:false },
    
  ]
};
*/

export const pasoFirmaFlujo1 = {
  paso: 5,
  titulo:"FIRMA DEL CONTRATANTE",
  /*textoPaso:"Paso 3 de 3",*/
  textoPaso:"Paso 2 de 2",
  pasos:[
    { activo:true },
    { activo:true },
   /* { activo:true },*/
    
  ]
};

//pasos de contratacion CT flujo 2 sin asegurados SA
export const pasoCTSAF2 = {
  paso: 1,
  titulo:"DATOS DEL CONTRATANTE (ASEGURADO TITULAR)",
  /*textoPaso:"Paso 1 de 3",*/
  textoPaso:"Paso 1 de 2",
  pasos:[
    { activo:true },
    { activo:false },
   /* { activo:false },*/
  ]
};

/*export const pasoDocsFlujo2 = {
  paso: 4,
  titulo:"CARGA DE DOCUMENTOS Y VALIDACIÓN DE DATOS",
  textoPaso:"Paso 2 de 3",
  pasos:[
    { activo:true },
    { activo:true },
    { activo:false },
    
  ]
};*/

export const pasoFirmaSAF2 = {
  paso: 5,
  titulo:"FIRMA DEL CONTRATANTE",
  /*textoPaso:"Paso 3 de 3",*/
  textoPaso:"Paso 2 de 2",
  pasos:[
    { activo:true },
    { activo:true },
    /*{ activo:true },*/
    
  ]
};

//pasos de contratacion CT flujo 2 con asegurados CA
export const pasoCTCAF2 = {
  paso: 1,
  titulo:"DATOS DEL CONTRATANTE (ASEGURADO TITULAR)",
  /*textoPaso:"Paso 1 de 4",*/
  textoPaso:"Paso 1 de 3",
  pasos:[
    { activo:true },
    { activo:false },
    { activo:false },
    /*{ activo:false },*/
  ]
};

export const  pasoAseguradosF2 = {
  paso: 3,
  titulo:"DATOS DE LOS DEPENDIENTES",
  /*textoPaso:"Paso 2 de 4",*/
  textoPaso:"Paso 2 de 3",
  pasos:[
    { activo:true },
    { activo:true },
    { activo:false },
    /*{ activo:false },*/
  ]
};

/*export const pasoDocsAseguradosFlujo2 = {
  paso: 4,
  titulo:"CARGA DE DOCUMENTOS Y VALIDACIÓN DE DATOS",
  textoPaso:"Paso 3 de 4",
  pasos:[
    { activo:true },
    { activo:true },
    { activo:true },
    { activo:false },
    
  ]
};*/

export const pasoFirmaCAF2 = {
  paso: 5,
  titulo:"FIRMA DEL CONTRATANTE",
  /*textoPaso:"Paso 4 de 4",*/
  textoPaso:"Paso 3 de 3",
  pasos:[
    { activo:true },
    { activo:true },
    { activo:true },
    /*{ activo:true },*/
    
  ]
};

//pasos de contratacion flujo 3 sin asegurados SA

export const pasoContratanteSAF3 = {
  paso: 1,
  titulo:"DATOS DEL CONTRATANTE",
  /*textoPaso:"Paso 1 de 4",*/
  textoPaso:"Paso 1 de 3",
  pasos:[
    { activo:true },
    { activo:false },
    { activo:false },
    /*{ activo:false },*/
  ]
};

export const pasoTitularSAF3 = {
  paso: 2,
  titulo:"DATOS DEL ASEGURADO TITULAR",
  /*textoPaso:"Paso 2 de 4",*/
  textoPaso:"Paso 2 de 3",
  pasos:[
    { activo:true },
    { activo:true },
    { activo:false },
    /*{ activo:false },*/
  ]
};

/*export const pasoDocsFlujo3 = {
  paso: 4,
  titulo:"CARGA DE DOCUMENTOS Y VALIDACIÓN DE DATOS",
  textoPaso:"Paso 3 de 4",
  pasos:[
    { activo:true },
    { activo:true },
    { activo:true },
    { activo:false },
    
  ]
};*/

export const pasoFirmaSAF3 = {
  paso: 5,
  titulo:"FIRMA DEL CONTRATANTE",
  /*textoPaso:"Paso 4 de 4",*/
  textoPaso:"Paso 3 de 3",
  pasos:[
    { activo:true },
    { activo:true },
    { activo:true },
    /*{ activo:true },*/
  ]
};

//pasos de contratacion flujo 3 con asegurados CA

export const pasoContratanteCAF3 = {
  paso: 1,
  titulo:"DATOS DEL CONTRATANTE",
  /*textoPaso:"Paso 1 de 5",*/
  textoPaso:"Paso 1 de 4",
  pasos:[
    { activo:true },
    { activo:false },
    { activo:false },
    { activo:false },
    /*{ activo:false },*/
  ]
};

export const pasoTitularCAF3 = {
  paso: 2,
  titulo:"DATOS DEL ASEGURADO TITULAR",
  /*textoPaso:"Paso 2 de 5",*/
  textoPaso:"Paso 2 de 4",
  pasos:[
    { activo:true },
    { activo:true },
    { activo:false },
    { activo:false },
    /*{ activo:false },*/
  ]
};

export const pasoAseguradosF3 = {
  paso: 3,
  titulo:"DATOS DE LOS DEPENDIENTES",
  /*textoPaso:"Paso 3 de 5",*/
  textoPaso:"Paso 3 de 4",
  pasos:[
    { activo:true },
    { activo:true },
    { activo:true },
    { activo:false },
    /*{ activo:false },*/
  ]
};

/*export const pasoDocsAseguradosFlujo3 = {
  paso: 4,
  titulo:"CARGA DE DOCUMENTOS Y VALIDACIÓN DE DATOS",
  textoPaso:"Paso 4 de 5",
  pasos:[
    { activo:true },
    { activo:true },
    { activo:true },
    { activo:true },
    { activo:false },
    
  ]
};*/

export const pasoFirmaCAF3 = {
  paso: 5,
  titulo:"FIRMA DEL CONTRATANTE",
  /*textoPaso:"Paso 5 de 5",*/
  textoPaso:"Paso 4 de 4",
  pasos:[
    { activo:true },
    { activo:true },
    { activo:true },
    { activo:true },
    /*{ activo:true },*/
  ]
};



export const ocupaciones = [{"nombre":"183","valor":"ABARROTERO","isAltoRiesgo":false},{"nombre":"2","valor":"ABOGADO","isAltoRiesgo":false},{"nombre":"185","valor":"ACTOR (no extras doblaje  / circo)","isAltoRiesgo":true},{"nombre":"186","valor":"ACTOR DE CIRCO","isAltoRiesgo":true},{"nombre":"187","valor":"ACTOR EXTRAS EN DOBLAJE","isAltoRiesgo":false},{"nombre":"188","valor":"ACTUARIO","isAltoRiesgo":false},{"nombre":"189","valor":"ADUANA FRONTERIZA (personal de)","isAltoRiesgo":false},{"nombre":"190","valor":"ADUANA NO FRONTERIZA (personal de)","isAltoRiesgo":false},{"nombre":"9","valor":"AGENTE DE COMPRAS,VTAS,VIAJES","isAltoRiesgo":false},{"nombre":"10","valor":"AGENTE DE SEGUROS Y FIANZAS","isAltoRiesgo":false},{"nombre":"193","valor":"AGRICULTOR","isAltoRiesgo":false},{"nombre":"195","valor":"AJUSTADOR DE SEGUROS","isAltoRiesgo":false},{"nombre":"196","valor":"ALBAÑIL","isAltoRiesgo":false},{"nombre":"356","valor":"ALCALDE","isAltoRiesgo":true},{"nombre":"17","valor":"AMA DE CASA","isAltoRiesgo":false},{"nombre":"199","valor":"ANESTESIOLOGO","isAltoRiesgo":true},{"nombre":"348","valor":"ANUNCIOS (exteriores)","isAltoRiesgo":false},{"nombre":"200","valor":"ANUNCIOS (obreros en taller)","isAltoRiesgo":true},{"nombre":"201","valor":"APICULTOR","isAltoRiesgo":false},{"nombre":"202","valor":"ARQUEÓLOGO","isAltoRiesgo":false},{"nombre":"203","valor":"ARQUITECTO","isAltoRiesgo":false},{"nombre":"204","valor":"ARTESANO","isAltoRiesgo":false},{"nombre":"205","valor":"ASTILLERO","isAltoRiesgo":false},{"nombre":"206","valor":"AVIACIÓN (pasaj vuelos partic.)","isAltoRiesgo":false},{"nombre":"207","valor":"AVICULTOR","isAltoRiesgo":false},{"nombre":"208","valor":"BACTERIÓLOGO","isAltoRiesgo":false},{"nombre":"361","valor":"BALLET AMATEUR","isAltoRiesgo":false},{"nombre":"362","valor":"BALLET PROFESIONAL","isAltoRiesgo":false},{"nombre":"209","valor":"BANQUERO","isAltoRiesgo":false},{"nombre":"210","valor":"BIÓLOGO","isAltoRiesgo":false},{"nombre":"211","valor":"BOMBERO","isAltoRiesgo":true},{"nombre":"212","valor":"BOTÁNICO","isAltoRiesgo":false},{"nombre":"213","valor":"CAJERO / TESORERO","isAltoRiesgo":false},{"nombre":"214","valor":"CALDERAS (personal en gral)","isAltoRiesgo":true},{"nombre":"215","valor":"CANTINERO","isAltoRiesgo":false},{"nombre":"378","valor":"CAPITAN DE BARCO","isAltoRiesgo":false},{"nombre":"216","valor":"CARGADOR (todo tipo)","isAltoRiesgo":false},{"nombre":"217","valor":"CARPINTERO","isAltoRiesgo":false},{"nombre":"218","valor":"CARTERO EN MOTO","isAltoRiesgo":false},{"nombre":"219","valor":"CERRAJERO","isAltoRiesgo":false},{"nombre":"220","valor":"CHOFER (todo tipo)","isAltoRiesgo":false},{"nombre":"221","valor":"COBRADOR","isAltoRiesgo":false},{"nombre":"222","valor":"COBRADOR EN MOTOCICLETA","isAltoRiesgo":false},{"nombre":"223","valor":"COCINERO","isAltoRiesgo":false},{"nombre":"224","valor":"COMERCIANTE (de animales domésticos)","isAltoRiesgo":false},{"nombre":"225","valor":"COMERCIANTE (de carnicerias)","isAltoRiesgo":false},{"nombre":"226","valor":"COMERCIANTE (de fierro viejo)","isAltoRiesgo":false},{"nombre":"45","valor":"COMERCIANTE (DE MAT. DE CONST)","isAltoRiesgo":false},{"nombre":"227","valor":"COMERCIANTE (de material  de construcción)","isAltoRiesgo":false},{"nombre":"46","valor":"COMERCIANTE (OTROS)","isAltoRiesgo":false},{"nombre":"47","valor":"CONTADOR","isAltoRiesgo":false},{"nombre":"230","valor":"CONTRATISTA","isAltoRiesgo":false},{"nombre":"231","valor":"CORREDOR DE APUESTAS (todos)","isAltoRiesgo":false},{"nombre":"50","valor":"DENTISTA","isAltoRiesgo":false},{"nombre":"233","valor":"DETECTIVE PRIVADO","isAltoRiesgo":false},{"nombre":"234","valor":"DIPLOMÁTICO","isAltoRiesgo":true},{"nombre":"350","valor":"DIPUTADO","isAltoRiesgo":true},{"nombre":"235","valor":"DOMADOR DE ANIMALES","isAltoRiesgo":true},{"nombre":"236","valor":"ELECTRICISTA","isAltoRiesgo":true},{"nombre":"370","valor":"EMPACADOR","isAltoRiesgo":false},{"nombre":"55","valor":"EMPLEADO ADMINISTRATIVO","isAltoRiesgo":false},{"nombre":"57","valor":"EMPLEADO DOMESTICO","isAltoRiesgo":false},{"nombre":"238","valor":"EMPLEADO EN VULCANIZADORA","isAltoRiesgo":true},{"nombre":"239","valor":"EMPRESARIO","isAltoRiesgo":false},{"nombre":"240","valor":"ENFERMERA","isAltoRiesgo":false},{"nombre":"379","valor":"ENTRENADOR / PROFESOR HOCKEY","isAltoRiesgo":false},{"nombre":"372","valor":"ENTRENADOR DE GIMNASIO","isAltoRiesgo":false},{"nombre":"241","valor":"ESCRITOR","isAltoRiesgo":false},{"nombre":"242","valor":"ESTIBADOR","isAltoRiesgo":false},{"nombre":"366","valor":"ESTILISTA / BARBERO","isAltoRiesgo":false},{"nombre":"61","valor":"ESTUDIANTE","isAltoRiesgo":false},{"nombre":"349","valor":"ESTUDIANTE PILOTO AVIADOR","isAltoRiesgo":false},{"nombre":"244","valor":"EXPLORADOR","isAltoRiesgo":true},{"nombre":"245","valor":"EXPLOSIVOS (fabricación, venta)","isAltoRiesgo":true},{"nombre":"172","valor":"EXTENSION COBERTURA EXT.","isAltoRiesgo":false},{"nombre":"171","valor":"EXTENSION EMERGENCIA EXTRAN.","isAltoRiesgo":false},{"nombre":"246","valor":"EXTERMINADOR DE PLAGAS","isAltoRiesgo":false},{"nombre":"249","valor":"FAB. DE ABRASIVOS / ACIDOS (c/maquinaria)","isAltoRiesgo":true},{"nombre":"247","valor":"FAB. DE ABRASIVOS / ACIDOS (oficina)","isAltoRiesgo":true},{"nombre":"248","valor":"FAB. DE ABRASIVOS / ACIDOS (supervisión)","isAltoRiesgo":true},{"nombre":"252","valor":"FAB. DE ARMAS DE FUEGO","isAltoRiesgo":true},{"nombre":"250","valor":"FAB. DE ARMAS DE FUEGO (c/maquinaria)","isAltoRiesgo":true},{"nombre":"251","valor":"FAB. DE ARMAS DE FUEGO (laboratorio/oficina)","isAltoRiesgo":true},{"nombre":"253","valor":"FABRICA DE VIDRIOS LAB / OFICINA","isAltoRiesgo":true},{"nombre":"254","valor":"FABRICA DE VIDRIOS LAB / SUPERVISÓN.","isAltoRiesgo":true},{"nombre":"255","valor":"FABRICA DE VIDRIOS RESTO DE PERSONAL","isAltoRiesgo":true},{"nombre":"256","valor":"FERROCARRILERO","isAltoRiesgo":false},{"nombre":"257","valor":"FISIOTERAPEUTICA","isAltoRiesgo":false},{"nombre":"258","valor":"FOGONERO","isAltoRiesgo":false},{"nombre":"260","valor":"FOTOGRAFO EN GENERAL","isAltoRiesgo":false},{"nombre":"261","valor":"FUMIGADOR","isAltoRiesgo":false},{"nombre":"262","valor":"FUNCIONARIO PUBLICO","isAltoRiesgo":false},{"nombre":"263","valor":"FUNDIDOR","isAltoRiesgo":false},{"nombre":"82","valor":"GANADERIA (EMPLEADO DE)","isAltoRiesgo":false},{"nombre":"83","valor":"GANADERIA (PROPIETARIO/ADMIST)","isAltoRiesgo":false},{"nombre":"266","valor":"GASOLINA, EXPENDIO DE (personal)","isAltoRiesgo":false},{"nombre":"267","valor":"GEÓLOGO","isAltoRiesgo":false},{"nombre":"352","valor":"GOBERNADOR","isAltoRiesgo":true},{"nombre":"268","valor":"GUARDA FORESTAL","isAltoRiesgo":true},{"nombre":"269","valor":"GUARDABOSQUE","isAltoRiesgo":true},{"nombre":"270","valor":"GUARDIA CON ARMA","isAltoRiesgo":true},{"nombre":"271","valor":"GUARDIA SIN ARMA","isAltoRiesgo":false},{"nombre":"272","valor":"GUÍA DE MONTAÑA","isAltoRiesgo":false},{"nombre":"273","valor":"GUÍA DE TURISTAS","isAltoRiesgo":false},{"nombre":"274","valor":"HERRERO","isAltoRiesgo":false},{"nombre":"275","valor":"HOJALATERO","isAltoRiesgo":false},{"nombre":"93","valor":"INGENIERO EN OFICINA","isAltoRiesgo":false},{"nombre":"276","valor":"INGENIERO EN OFICINA / O EN SUPERVISIÓN","isAltoRiesgo":false},{"nombre":"277","valor":"INSTALADOR DE ANTENAS","isAltoRiesgo":false},{"nombre":"365","valor":"INSTALADOR DE CÁMARAS Y ALARMAS DOMESTICAS","isAltoRiesgo":false},{"nombre":"278","valor":"INSTRUCTOR DE MANEJO","isAltoRiesgo":false},{"nombre":"377","valor":"INTENDENCIA / LIMPIEZA (SIN ALTURA)","isAltoRiesgo":false},{"nombre":"279","valor":"JOYERO","isAltoRiesgo":false},{"nombre":"280","valor":"JUBILADO","isAltoRiesgo":false},{"nombre":"353","valor":"JUEZ","isAltoRiesgo":false},{"nombre":"281","valor":"LANCHERO","isAltoRiesgo":false},{"nombre":"100","valor":"LICENCIADO EN ADM. DE EMPRESAS","isAltoRiesgo":false},{"nombre":"283","valor":"LIDER SINDICAL","isAltoRiesgo":true},{"nombre":"371","valor":"LIMPIADOR DE ACUARIOS","isAltoRiesgo":false},{"nombre":"284","valor":"LIMPIADOR DE VENTANAS (edificio)","isAltoRiesgo":true},{"nombre":"367","valor":"MAESTRO (A) DE BAILE EN PISO","isAltoRiesgo":false},{"nombre":"373","valor":"MAESTRO DE NATACIÓN","isAltoRiesgo":false},{"nombre":"376","valor":"MAESTRO DE SURF","isAltoRiesgo":false},{"nombre":"359","valor":"MAGISTRADO","isAltoRiesgo":true},{"nombre":"374","valor":"MANT./REPARACIONES/REMODELACIÓN (NO MAQUINARIA)","isAltoRiesgo":false},{"nombre":"285","valor":"MARINERO","isAltoRiesgo":false},{"nombre":"286","valor":"MASAJISTA","isAltoRiesgo":false},{"nombre":"287","valor":"MECANICO (todo tipo)","isAltoRiesgo":false},{"nombre":"288","valor":"MÉDICO","isAltoRiesgo":true},{"nombre":"290","valor":"MENSAJERO EN MOTOCICLETA","isAltoRiesgo":false},{"nombre":"291","valor":"MILITAR","isAltoRiesgo":true},{"nombre":"292","valor":"MINERO","isAltoRiesgo":true},{"nombre":"354","valor":"MINISTRO","isAltoRiesgo":true},{"nombre":"293","valor":"MODELO","isAltoRiesgo":false},{"nombre":"294","valor":"MODISTA","isAltoRiesgo":false},{"nombre":"112","valor":"MOTOCICLISTA","isAltoRiesgo":false},{"nombre":"295","valor":"MÚSICO","isAltoRiesgo":false},{"nombre":"0","valor":"NINGUNA","isAltoRiesgo":false},{"nombre":"296","valor":"NOTARIO","isAltoRiesgo":false},{"nombre":"369","valor":"NUTRIÓLOGO","isAltoRiesgo":false},{"nombre":"297","valor":"OBRERO","isAltoRiesgo":false},{"nombre":"363","valor":"OFTALMÓLOGO","isAltoRiesgo":false},{"nombre":"298","valor":"OPERADOR DE CUALQUIER TIPO DE MAQ","isAltoRiesgo":false},{"nombre":"299","valor":"OPERADOR DE TODO MAQ. PESADA","isAltoRiesgo":false},{"nombre":"380","valor":"OPTOMETRISTA","isAltoRiesgo":false},{"nombre":"300","valor":"PERFORADOR PLATAFORMAS","isAltoRiesgo":false},{"nombre":"301","valor":"PERIODISTAS","isAltoRiesgo":false},{"nombre":"303","valor":"PESCADOR","isAltoRiesgo":false},{"nombre":"304","valor":"PILOTO AVIADOR NO PROFESIONAL Y PROFESIONAL","isAltoRiesgo":false},{"nombre":"305","valor":"PINTOR COMERCIAL DE EXTERIORES (alturas)","isAltoRiesgo":true},{"nombre":"306","valor":"PINTOR COMERCIAL DE INTERIORES","isAltoRiesgo":false},{"nombre":"307","valor":"PINTOR COMERCIAL DE PUENTES","isAltoRiesgo":false},{"nombre":"308","valor":"PLANTA ARMADORA AUTO (capataz)","isAltoRiesgo":false},{"nombre":"309","valor":"PLANTA ARMADORA AUTO (oficina)","isAltoRiesgo":false},{"nombre":"310","valor":"PLANTA ARMADORA AUTO RES/PERS","isAltoRiesgo":false},{"nombre":"311","valor":"PLOMERO","isAltoRiesgo":false},{"nombre":"312","valor":"POLICÍA BANCARIO","isAltoRiesgo":false},{"nombre":"313","valor":"POLICÍA DE CAMINOS","isAltoRiesgo":false},{"nombre":"314","valor":"POLICÍA JUDICIAL","isAltoRiesgo":false},{"nombre":"315","valor":"POLICÍA PREVENTIVO","isAltoRiesgo":true},{"nombre":"316","valor":"PRESAS, DIQUES, MUELLES (oficina)","isAltoRiesgo":false},{"nombre":"317","valor":"PRESAS, DIQUES, MUELLES GUARDIAS","isAltoRiesgo":false},{"nombre":"318","valor":"PRESAS, DIQUES, MUELLES T/OBRERO","isAltoRiesgo":false},{"nombre":"355","valor":"PRESIDENTE MUNICIPAL","isAltoRiesgo":true},{"nombre":"358","valor":"PROCURADOR","isAltoRiesgo":true},{"nombre":"142","valor":"PROFESOR","isAltoRiesgo":false},{"nombre":"368","valor":"PSICÓLOGO / PSIQUIATRA","isAltoRiesgo":false},{"nombre":"360","valor":"QUÍMICO (CON MANEJO DE SUSTANCIAS)","isAltoRiesgo":false},{"nombre":"364","valor":"RADIÓLOGO","isAltoRiesgo":false},{"nombre":"321","valor":"RASTROS / FRIGORIFICOS (inspección)","isAltoRiesgo":false},{"nombre":"322","valor":"RASTROS / FRIGORIFICOS (obreros)","isAltoRiesgo":false},{"nombre":"323","valor":"REFINERIAS (ingeniero)","isAltoRiesgo":false},{"nombre":"324","valor":"REFINERIAS (lab. oficinas)","isAltoRiesgo":false},{"nombre":"325","valor":"REFINERIAS PERSONAL ADMINISTRATIVOS","isAltoRiesgo":false},{"nombre":"326","valor":"REFINERIAS RESTOS DEL PERSONAL","isAltoRiesgo":false},{"nombre":"327","valor":"REPARTIDOR DE GAS","isAltoRiesgo":false},{"nombre":"328","valor":"REPARTIDOR EN GENERAL (no en motocicleta)","isAltoRiesgo":false},{"nombre":"329","valor":"REPORTERO (en conflicto mili)","isAltoRiesgo":false},{"nombre":"330","valor":"REPORTERO (no conflicto mili)","isAltoRiesgo":false},{"nombre":"331","valor":"SACERDOTE","isAltoRiesgo":false},{"nombre":"332","valor":"SALINAS (trabajadores de)","isAltoRiesgo":false},{"nombre":"333","valor":"SALVAVIDAS DE ALBERCA","isAltoRiesgo":false},{"nombre":"334","valor":"SALVAVIDAS DE PLAYA","isAltoRiesgo":false},{"nombre":"357","valor":"SECRETARIO DE ESTADO","isAltoRiesgo":true},{"nombre":"351","valor":"SENADOR","isAltoRiesgo":true},{"nombre":"335","valor":"SOCORRISTA (todo tipo)","isAltoRiesgo":true},{"nombre":"336","valor":"SOLDADOR (no en altura)","isAltoRiesgo":false},{"nombre":"337","valor":"SOLDADOR EN ALTURA","isAltoRiesgo":true},{"nombre":"338","valor":"TALLERES MECÁNICOS (personal administrativos)","isAltoRiesgo":false},{"nombre":"381","valor":"TATUADOR","isAltoRiesgo":false},{"nombre":"339","valor":"TERAPEUTA","isAltoRiesgo":false},{"nombre":"340","valor":"TORERO PROFESIONAL","isAltoRiesgo":true},{"nombre":"341","valor":"TORNOS (operador de)","isAltoRiesgo":false},{"nombre":"342","valor":"TORTILLERIAS (personal)","isAltoRiesgo":false},{"nombre":"343","valor":"TRANSPORTISTAS","isAltoRiesgo":false},{"nombre":"344","valor":"TROQUELADOR","isAltoRiesgo":false},{"nombre":"345","valor":"VELADOR","isAltoRiesgo":false},{"nombre":"166","valor":"VETERINARIO","isAltoRiesgo":false},{"nombre":"347","valor":"ZOOLOGO","isAltoRiesgo":false}]
export const paises = ['Albania ',
'Alemania ',
'Andorra ',
'Angola ',
'Antigua y Barbuda ',
'Arabia Saudita ',
'Argelia ',
'Argentina ',
'Armenia ',
'Australia ',
'Austria ',
'Azerbaiyán ',
'Bahamas ',
'Bahrein ',
'Bangladesh ',
'Barbados ',
'Belarús ',
'Belice ',
'Benin ',
'Bhután ',
'Bolivia (Estado Plurinacional de) ',
'Bosnia y Herzegovina ',
'Botswana ',
'Brasil ',
'Brunei Darussalam ',
'Bulgaria ',
'Burkina Faso ',
'Burundi ',
'Bélgica ',
'Cabo Verde ',
'Camboya ',
'Camerún ',
'Canadá ',
'Chad ',
'Chequia ',
'Chile ',
'China ',
'Chipre ',
'Colombia ',
'Comoras ',
'Congo ',
'Costa Rica ',
'Croacia ',
'Cuba ',
'Côte dIvoire ',
'Dinamarca ',
'Djibouti ',
'Dominica ',
'Ecuador ',
'Egipto ',
'El Salvador ',
'Emiratos Árabes Unidos ',
'Eritrea ',
'Eslovaquia ',
'Eslovenia ',
'España ',
'Estados Unidos de América ',
'Estonia ',
'Eswatini ',
'Etiopía ',
'Federación de Rusia ',
'Fiji ',
'Filipinas ',
'Finlandia ',
'Francia ',
'Gabón ',
'Gambia ',
'Georgia ',
'Ghana ',
'Granada ',
'Grecia ',
'Guatemala ',
'Guinea ',
'Guinea Ecuatorial ',
'Guinea-Bissau ',
'Guyana ',
'Haití ',
'Honduras ',
'Hungría ',
'India ',
'Indonesia ',
'Iraq ',
'Irlanda ',
'Irán (República Islámica del) ',
'Islandia ',
'Islas Cook ',
'Islas Feroe  ',
'Islas Marshall ',
'Islas Salomón ',
'Israel ',
'Italia ',
'Jamaica ',
'Japón ',
'Jordania ',
'Kazajstán ',
'Kenya ',
'Kirguistán ',
'Kiribati ',
'Kuwait ',
'Lesotho ',
'Letonia ',
'Liberia ',
'Libia ',
'Lituania ',
'Luxemburgo ',
'Líbano ',
'Macedonia del Norte  ',
'Madagascar ',
'Malasia ',
'Malawi ',
'Maldivas ',
'Malta ',
'Malí ',
'Marruecos ',
'Mauricio ',
'Mauritania ',
'Micronesia (Estados Federados de) ',
'Mongolia ',
'Montenegro ',
'Mozambique ',
'Myanmar ',
'México ',
'Mónaco ',
'Namibia ',
'Nauru ',
'Nepal ',
'Nicaragua ',
'Nigeria ',
'Niue ',
'Noruega ',
'Nueva Zelandia ',
'Níger ',
'Omán ',
'Pakistán ',
'Palau ',
'Panamá ',
'Papua Nueva Guinea ',
'Paraguay ',
'Países Bajos ',
'Perú ',
'Polonia ',
'Portugal ',
'Qatar ',
'Reino Unido de Gran Bretaña e Irlanda del Norte ',
'República Centroafricana ',
'República Democrática Popular Lao ',
'República Democrática del Congo ',
'República Dominicana ',
'República Popular Democrática de Corea ',
'República Unida de Tanzanía ',
'República de Corea ',
'República de Moldova ',
'República Árabe Siria ',
'Rumania ',
'Rwanda ',
'Saint Kitts y Nevis ',
'Samoa ',
'San Marino ',
'San Vicente y las Granadinas ',
'Santa Lucía ',
'Santo Tomé y Príncipe ',
'Senegal ',
'Serbia ',
'Seychelles ',
'Sierra Leona ',
'Singapur ',
'Somalia ',
'Sri Lanka ',
'Sudáfrica ',
'Sudán ',
'Sudán del Sur ',
'Suecia ',
'Suiza ',
'Suriname ',
'Tailandia ',
'Tayikistán ',
'Timor-Leste ',
'Togo ',
'Tokelau  ',
'Tonga ',
'Trinidad y Tabago ',
'Turkmenistán ',
'Turquía ',
'Tuvalu ',
'Túnez ',
'Ucrania ',
'Uganda ',
'Uruguay ',
'Uzbekistán ',
'Vanuatu ',
'Venezuela (República Bolivariana de) ',
'Viet Nam ',
'Yemen ',
'Zambia ',
'Zimbabwe '];